import { ReactNode } from 'react';
import clsx from 'clsx';
import { usePopupStore } from '../../stores';

interface GroupProps {
  show?: boolean;
  className?: string;
  children: ReactNode;
}

export function Group({ show = false, className, children }: GroupProps) {
  const isWebChatOpen = usePopupStore.use.isWebChatOpen();

  return (
    <div
      className={clsx(
        'tlw-bottom-0 tlw-z-75',
        isWebChatOpen ? 'tlw-static lg:tlw-sticky' : 'tlw-sticky'
      )}
    >
      <div
        className={clsx(
          'tlw-absolute tlw-right-2 tlw-flex tlw-w-fit tlw-flex-col tlw-gap-2 tlw-transition-opacity',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
